import React from 'react';

function EdgeStaticField({ label, value = '' }) {
  return (
    <div className="staticField">
      <div className="label">
        {label}
        <div className="value">{value}</div>
      </div>
    </div>
  );
}

export default EdgeStaticField;
